'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('whatwg-fetch');

var _immutable = require('immutable');

var _RenderForm = require('./RenderForm');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SYSTEM_KEYS = [_RenderForm.TC_ID, 'quiz_complete', 'browser_id', 'recaptcha_id'];
var PRIMARY_KEYS = ['name', 'surname', 'email', 'telephone', 'browser_id', 'recaptcha_id'];
var CUSTOM_KEYS = ['checkbox', 'checkboxLink', 'number', 'text'];

var LeadSubmitter = function () {
  function LeadSubmitter(apiBaseUrl) {
    _classCallCheck(this, LeadSubmitter);

    this.apiBaseUrl = apiBaseUrl;
  }

  _createClass(LeadSubmitter, [{
    key: 'submitLead',
    value: function submitLead(settings, lead, quizId, publishedAt, answers, quizType) {
      function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
      }

      var transformed = this._transformLead(settings, lead, quizId, publishedAt, answers, quizType);
      transformed.hs_context = {
        pageUrl: !!window && window.location.href || null,
        pageName: !!document && document.title || null
      };
      if (!!getCookie('hubspotutk')) transformed.hs_context.hutk = getCookie('hubspotutk');
      console.log('Submitting Lead');
      window.isSubmittinglead = true;
      fetch(this.apiBaseUrl + '/leads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(transformed)
      }).then(function (res) {
        window.isSubmittinglead = false;
        if (!res.ok) {
          console.error('Failed to send data to the server', res);
        }
        console.log('Lead Submit complete');
      });
    }
  }, {
    key: '_transformLead',
    value: function _transformLead(settings, leadData, quizId, publishedAt, answers, quizType) {
      var calculatedScore = this._calculateScore(answers);
      if (quizType && quizType === 'Course Finder') {
        var answersArr = Object.keys(answers.toJS()).map(function (answerKey) {
          return answers.get(answerKey);
        });
        var firstScore = answersArr.map(function (a) {
          return parseInt(a.level) || false;
        }).find(function (a) {
          return a;
        });
        calculatedScore = firstScore ? firstScore * 0.1 : 0;
      }
      return Object.assign({
        territory_id: settings.get('id'),
        quiz_id: quizId,
        published_at: publishedAt,
        answers: answers.toJS(),
        score: calculatedScore
      }, this._transformLeadData(leadData, quizType));
    }
  }, {
    key: '_transformLeadData',
    value: function _transformLeadData(leadData, quizType) {
      var usedKeys = new _immutable.Set();
      var lead = leadData.get('values').mapEntries(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        if (SYSTEM_KEYS.indexOf(k) >= 0) {
          return [k, v];
        }

        var fieldType = leadData.get('fieldsInfo').get(k).get('type');
        var filedName = leadData.get('fieldsInfo').get(k).get('name');
        var proposedKey = fieldType;

        if (CUSTOM_KEYS.indexOf(proposedKey) >= 0) {
          proposedKey = k;
        }

        var i = 2;
        while (usedKeys.has(proposedKey)) {
          proposedKey = fieldType + '-' + i++;
        }

        if (['customSelect'].includes(fieldType)) {
          return [filedName, { name: filedName, type: 'additional', value: v }];
        }

        if (fieldType === 'additional') {
          return [k, { name: k, type: 'additional', value: v }];
        }

        return [proposedKey, { name: filedName, type: fieldType, value: v }];
      });

      var transformed = {
        other_data: Object.assign({}, { quizType: quizType }, lead.toJS())
      };
      PRIMARY_KEYS.forEach(function (key) {
        if (transformed.other_data[key]) {
          transformed[key] = transformed.other_data[key].value || transformed.other_data[key];
          delete transformed.other_data[key];
        }
      });
      return transformed;
    }
  }, {
    key: '_calculateScore',
    value: function _calculateScore(answers) {
      return answers.filter(function (v) {
        return v.correct;
      }).size / answers.size;
    }
  }]);

  return LeadSubmitter;
}();

exports.default = LeadSubmitter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/LeadSubmitter.js
// module id = 860
// module chunks = 0